import { getId } from "@/helpers/utils";
import axiosHelper from "@/helpers/axios-helper";
import { service_paths } from "@/constants/Services";
import CalendarConst from "@/constants/Calendar";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import i18n from "../../../lang/i18n";

export const EVENT_TYPES = CalendarConst.EVENT_TYPES;

const _getEditable = (userRole, eventType) => {
  if (hasValidRole(userRole, [Role.Admin, Role.Principal])) {
    return true;
  }
  return false;
};

export const BACKGROUND_COLORS = {
  event: "#4CAF50",
  holiday: "#999999",
  activity: "#9C27B0",
  schedule: "#FF9801",
  meeting: "#1F88F8",
  cancel: "#f44336"
};

export const EVENT_CATEGORIES = {
  event: i18n.t("schedule.event"),
  holiday: i18n.t("schedule.holiday"),
  activity: i18n.t("schedule.activity"),
  schedule: i18n.t("schedule.class_schedule"),
  meeting: i18n.t("schedule.virtual_meeting"),
  cancel: i18n.t("schedule.canceled_meeting")
};

export const SCHEDULE_TYPES = {
  singleEvent: {
    // one-day class schedule or school event
    title: i18n.t("schedule.this_schedule"),
    value: "This schedule"
  },
  chainEvent: {
    title: i18n.t("schedule.follow_schedules"),
    value: "This and the following schedules"
  },
  allEvent: {
    title: i18n.t("schedule.all_schedules"),
    value: "All schedules"
  }
};

export const REPEAT_TIMES = CalendarConst.REPEAT_TIMES;

export function convertSISEvent2CalendarEvent(userRole, sisEvent) {
  const isClassSchedule = sisEvent.type === EVENT_TYPES.classEvent;
  const isVirtualMeeting = sisEvent.type === EVENT_TYPES.meetingEvent;

  const title = isClassSchedule ? sisEvent.class?.name : sisEvent.name;
  let eventBgColor = "";
  if (isClassSchedule) {
    eventBgColor = BACKGROUND_COLORS.schedule;
  } else if (isVirtualMeeting) {
    eventBgColor = BACKGROUND_COLORS.meeting;
  } else if (sisEvent.type === "canceled") {
    eventBgColor = BACKGROUND_COLORS.cancel;
  } else {
    eventBgColor = BACKGROUND_COLORS[sisEvent.category];
  }

  // sisEvent not contain category when it's class schedule
  const eventCategory = sisEvent.category || "schedule";
  const editable = _getEditable(userRole, sisEvent.type);

  return {
    id: getId(sisEvent),
    title,
    start: sisEvent.start,
    end: sisEvent.end,
    allDay: sisEvent.is_all_day,
    backgroundColor: eventBgColor,
    extendedProps: {
      ...sisEvent,
      category: eventCategory
    },
    editable
  };
}

export const EventAPI = {
  add({ eventType, eventConfig, overlayLoading = true }) {
    const isSchoolEvent = eventType === EVENT_TYPES.schoolEvent;
    const subPath = isSchoolEvent ? "/school-event" : "/class-schedule";
    return axiosHelper.post(
      `${service_paths.calendars}${subPath}`,
      eventConfig,
      undefined,
      undefined,
      undefined,
      overlayLoading
    );
  },
  edit(
    eventId,
    { eventType, eventConfig, overlayLoading = true },
    isDropUpdating = false
  ) {
    let mainPath = `${service_paths.calendars}/${eventId}`;

    const requestUpdateEvent = path =>
      axiosHelper.put(
        path,
        eventConfig,
        undefined,
        undefined,
        undefined,
        overlayLoading
      );

    const isSchoolEvent = eventType === EVENT_TYPES.schoolEvent;
    const isClassSingleEvent = !isSchoolEvent && !eventConfig.option;

    if (isDropUpdating || isClassSingleEvent) {
      return requestUpdateEvent(`${mainPath}/single`);
    }

    if (isSchoolEvent) {
      return requestUpdateEvent(`${mainPath}/school-event`);
    }

    return requestUpdateEvent(`${mainPath}/class-schedule`);
  }
};
